<template>
<v-dialog v-model="displayForm" persistent max-width="980px">
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-card-title>
        {{item ? 'Update Location' : 'Add Location'}}
      </v-card-title>
      <div class="text-xs-center" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <v-card-text v-else>
        <v-row>
          <v-col>
            <v-text-field v-model="model.name" label="Name" :rules="mandatoryRules"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <country-autocomplete v-model="model.country" :rules="mandatoryRules" label="Country"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="item"
          dark
          primary
          @click="update()"
          :disabled="loading"
        >Update</v-btn>
        <v-btn v-else color="blue darken-1" text @click="add()" :disabled="loading">Add</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-dialog>
</template>

<script>

function getDefaultData() {
  return {
    model: {
      id: null,
      name: null,
      country: null
    },
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    message: null,
    valid: null
  };
}
import CountryAutocomplete from "@components/forms/autocomplete/Country.vue";

export default {
  components: {CountryAutocomplete},
  props: ["item", "open"],
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
    loading: function() {
      return this.$store.getters["locations/loading"];
    }
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
    }
  },
  methods: {
    add() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("locations/add", {
            model: this.model
          })
          .then(result => {
            if (result.location.id) {
              this.$emit("add");
              this.resetForm();
              this.flashMessage.success({
                message: "Location created successfuly",
              })
            } else {
              this.message = result.message;
            }
          })
          .catch(({data})=>{
            this.flashMessage.error({
              message: data.message,
            })
          });
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("locations/update", {
            model: this.model
          })
          .then(result => {
            if (result.location.id) {
              console.log(result);
              this.$emit("update");
              this.resetForm();
              this.flashMessage.success({
                message: "Location updated successfuly",
              })
            } else {
              this.message = result.message;
            }
          })
          .catch(({data}) => {
            this.flashMessage.error({
              message: data.message,
            })
          });
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
